import React, { useEffect, useState } from 'react';
import { ArrowsOut, ArrowSquareOut, CircleNotch, Eye } from '@phosphor-icons/react';
import { ladeVorschau } from '../../../../lib/dokumente/altarchivPruefung';

/** PDF aus dem OneDrive-Altarchiv ansehen – lädt erst auf Klick (jede Vorschau ist ein Graph-Abruf). */
export function PruefVorschau({ dokumentId, dateiname, onedriveUrl, mobil }: { dokumentId: string; dateiname: string; onedriveUrl: string | null; mobil: boolean }) {
  const [zeigen, setZeigen] = useState(false);
  const [url, setUrl] = useState<string | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [gross, setGross] = useState(false);

  useEffect(() => {
    if (!zeigen) return;
    let aktiv = true;
    let objUrl: string | null = null;
    setFehler(null);
    ladeVorschau(dokumentId)
      .then(b => { if (!aktiv) return; objUrl = URL.createObjectURL(b); setUrl(objUrl); })
      .catch((e: unknown) => { if (aktiv) setFehler(e instanceof Error ? e.message : 'Vorschau fehlgeschlagen'); });
    return () => { aktiv = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [zeigen, dokumentId]);

  const knopf: React.CSSProperties = {
    height: mobil ? 44 : 32, padding: '0 12px', borderRadius: 11, border: 'none', display: 'inline-flex', alignItems: 'center', gap: 6,
    fontSize: 12, fontWeight: 700, background: 'var(--fill2)', color: 'var(--ink)', cursor: 'pointer', textDecoration: 'none',
  };

  return (
    <div className="flex flex-col" style={{ gap: 8 }}>
      {zeigen && !url && !fehler && (
        <div className="flex items-center justify-center" style={{ height: 160, borderRadius: 16, background: 'var(--fill2)' }} aria-busy="true">
          <CircleNotch size={18} className="animate-spin" color="var(--ink3)" />
        </div>
      )}
      {fehler && <p style={{ margin: 0, fontSize: 12, color: 'var(--bad)' }}>Vorschau fehlgeschlagen: {fehler}</p>}
      {url && (
        // Blob-Typ ist fest application/pdf (siehe ladeVorschau) – kein Skript-Kontext.
        <iframe src={url} title={dateiname} referrerPolicy="no-referrer"
          style={{ width: '100%', height: gross ? '70vh' : 360, border: 'none', borderRadius: 16, background: '#fff', boxShadow: 'inset 0 0 0 1px var(--line)' }} />
      )}
      <div className="flex items-center flex-wrap" style={{ gap: 6 }}>
        {!zeigen && <button type="button" style={knopf} onClick={() => setZeigen(true)}><Eye size={14} weight="bold" />Vorschau anzeigen</button>}
        {url && <button type="button" style={knopf} onClick={() => setGross(g => !g)}><ArrowsOut size={14} weight="bold" />{gross ? 'Kleiner' : 'Größer'}</button>}
        {onedriveUrl && <a href={onedriveUrl} target="_blank" rel="noreferrer" style={knopf}><ArrowSquareOut size={14} weight="bold" />In OneDrive öffnen</a>}
      </div>
    </div>
  );
}
